export enum SafeActions {
  Difference = 'Difference',
  Protectas = 'Protectas',
  CashIn = 'CashIn',
  CashOut = 'CashOut'
}
